import notificationModule from './notification-module';
import cardsModule from './cards';
import awardsModule from './awards';
import userModule from './users';
import roleModule from './roles';
import faqsModule from './faqs';
import reportsModule from './reports';
import banksModule from './banks';
import subscriptionModule from './subscriptions';

// Export the modules in the order they should appear in the navigation menu
const modules = [
  notificationModule,
  cardsModule,
  awardsModule,
  userModule,
  roleModule,
  subscriptionModule,
  faqsModule,
  reportsModule,
  banksModule
];

export { modules };
